import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { ButtonWrap, AnchorButton, HashButton } from './button.style';

const Button = ({
  children,
  $icon,
  $path = null,
  $fontSize = '20px',
  $fontWeight = 500,
  $skin = 'primary',
  $size = 'medium',
  $shape = 'rounded',
  $color = '',
  $bgColor = '',
  $borderWidth = '1px',
  $iconposition = 'right',
  $hover = { $bgColor: 'secondary' },
  $uppercase = false,
  ...rest
}) => {
  const restProps = {
    $path,
    $fontSize,
    $fontWeight,
    $skin,
    $size,
    $shape,
    $color,
    $bgColor,
    $borderWidth,
    $iconposition,
    $hover,
    $uppercase,
    ...rest,
  };

  const internal = /^\/(?!\/)/.test($path);

  if ($path) {
    const isHash = $path.startsWith('#');
    if (internal) {
      return (
        <ButtonWrap as={Link} to={$path} {...restProps}>
          {$iconposition === 'left' && $icon && <span className="btn-icon">{$icon}</span>}
          {children}
          {$iconposition === 'right' && $icon && <span className="btn-icon">{$icon}</span>}
        </ButtonWrap>
      );
    }
    if (isHash) {
      return (
        <HashButton href={$path} {...restProps}>
          {children}
        </HashButton>
      );
    }
    return (
      <AnchorButton href={$path} {...restProps}>
        {$iconposition === 'left' && $icon && <span className="btn-icon">{$icon}</span>}
        {children}
        {$iconposition === 'right' && $icon && <span className="btn-icon">{$icon}</span>}
      </AnchorButton>
    );
  }
  return (
    <ButtonWrap path={$path} {...restProps}>
      {$iconposition === 'left' && $icon && <span className="btn-icon">{$icon}</span>}
      {children}
      {$iconposition === 'right' && $icon && <span className="btn-icon">{$icon}</span>}
    </ButtonWrap>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  $path: PropTypes.string,
  onClick: PropTypes.func,
  $fontSize: PropTypes.string,
  $fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  $color: PropTypes.string,
  $bgColor: PropTypes.string,
  $skin: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
    'gradient',
    'transparent',
  ]),
  $size: PropTypes.oneOf(['large', 'medium', 'small', 'xsmall']),
  $shape: PropTypes.oneOf(['rectangle', 'rounded', 'bullet']),
  $varient: PropTypes.oneOf(['outlined', 'texted', 'underlined', 'onlyIcon', 'contained']),
  $borderWidth: PropTypes.string,
  $hover: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.object]),
  $minwidth: PropTypes.string,
  $fullwidth: PropTypes.bool,
  $iconposition: PropTypes.string,
  $spacer: PropTypes.object,
  $uppercase: PropTypes.bool,
};

export default Button;
